'use strict';

import Components from './components';

export default class {

    init() {

        if (document.getElementById('product-filter')) {
            Components.register(Vue);
        }
        
    }
}
